// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-iga","label":"styles_label__zp5kZ"};